import { LegalEntityAuditApiModel } from "./LegalEntityAudit.types";
import { useState } from "react";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useLegalEntityAuditTabDataMapping(legalEntityId: string | undefined, legalEntityName: string, onAuditsChanged: () => void) {
    const url = `/legalEntityAudit/getAll/${legalEntityId}`;
    let { isLoading, data: audits, refetch } = useDotLegalQuery<Array<LegalEntityAuditApiModel>>(url);
    const [selectedAudit, setSelectedAudit] = useState<LegalEntityAuditApiModel | undefined>(undefined);

    const [showDialog, setShowDialog] = useState(false);
    const [showCopyDialog, setShowCopyDialog] = useState(false);
    const [showRegisterDialog, setShowRegisterDialog] = useState(false);

    const refetchAudits = () => {
        refetch();
        onAuditsChanged();
    };

    const onSendAuditClick = () => {
        setShowDialog(true);
    };

    const onAuditSent = () => {
        setShowDialog(false);
        refetchAudits();
    };

    const onAuditCopied = () => {
        refetchAudits();
    };

    return {
        onSendAuditClick,
        showDialog,
        setShowDialog,
        audits,
        isLoading,
        onAuditSent,
        onAuditCopied,
        showCopyDialog,
        setShowCopyDialog,
        selectedAudit,
        setSelectedAudit,
        refetchAudits,
        showRegisterDialog,
        setShowRegisterDialog,
    };
}
